import React from 'react';
import { Route, Routes, Navigate, useNavigate, useLocation } from 'react-router-dom';
import Menu from '../../componentes/menu';
import { usuarioSignal } from '../../signals/usuario';
// Formulários globais
import NaoAutorizado from '../error/NaoAutorizado';
/* @useSignals */
import { Box } from '@mui/material';
import Credenciais from './credenciais/Credenciais';
import Modulos from './modulos';
import Parceiros from './parceiros';
import ProtectedRoute from './protectedRoute';
import { Funcionalidade } from '@stt-console/util';

const podeAcessarParceiros = (rbac) => rbac.temPermissao(Funcionalidade.PAGINA_PARCEIROS) || rbac.ehAdminParceiroRestrito();

const obterPaginaInicial = () => {
    const rbac = usuarioSignal.value.rbac;
    if (rbac.temPermissao(Funcionalidade.PAGINA_CREDENCIAIS)) {
        return '/credenciais';
    }
    if (rbac.temPermissao(Funcionalidade.PAGINA_MODULOS)) {
        return '/modulos';
    }
    if (podeAcessarParceiros(rbac)) {
        return '/parceiros';
    }
    return '/nao-autorizado';
};

const Interno = () => {
    return (
        <>
            {usuarioSignal.value.autenticado ? (
                <Box sx={{ paddingBottom: 4 }}>
                    <Menu />
                    <Routes>
                        <Route path="/" element={<Navigate to={obterPaginaInicial()} />} />
                        <Route path="/credenciais" element={<ProtectedRoute component={Credenciais} funcionalidade={Funcionalidade.PAGINA_CREDENCIAIS} />} />
                        <Route path="/modulos" element={<ProtectedRoute component={Modulos} funcionalidade={Funcionalidade.PAGINA_MODULOS} />} />
                        <Route path="/parceiros" element={<ProtectedRoute component={Parceiros} predicado={podeAcessarParceiros} />} />
                        <Route path="/nao-autorizado" element={<NaoAutorizado />} />
                        <Route path="*" element={<Navigate replace to="/" />} />
                    </Routes>
                </Box>
            ) : (
                <Box sx={{ paddingBottom: 4 }}>
                    <NaoAutorizado />
                </Box>
            )}
        </>
    );
};

export default Interno;
